import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute top-8 right-8 text-gray-400" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-0.5 font-medium text-[9px]" }, "ESC", -1)
const _hoisted_3 = {
  key: 0,
  class: "mb-8 mr-14"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { computed, ref, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    subtitle: null,
    noPadding: { type: Boolean },
    size: null,
    close: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string,
  subtitle?: string,
  noPadding?: boolean,
  size?: 'lg',
  close:() => void,
}



const {
  title, subtitle, noPadding, size, close,
} = toRefs(props);
const panel = ref(null);

const sidepageSize = computed(() => {
  if (size?.value === 'lg') return 'sm:max-w-2xl';
  return 'sm:max-w-lg';
});

return (_ctx: any,_cache: any) => {
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_base_overlay = _resolveComponent("base-overlay")!

  return (_openBlock(), _createBlock(_component_base_overlay, {
    panel: panel.value,
    close: _unref(close)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute inset-y-0 right-0 w-full bg-white/90 backdrop-blur-lg border border-blue-50 shadow-xl shadow-blue-700/30 overflow-y-auto", [_unref(sidepageSize), _unref(noPadding) ? '' : 'p-8']]),
        ref_key: "panel",
        ref: panel,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "sidepage-headline"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args))),
            class: "p-1.5 border border-gray-300 hover:bg-white hover:text-gray-700 hover:border-gray-700 rounded-md"
          }, [
            _createVNode(_component_icon_x, { class: "h-5 w-5" })
          ]),
          _hoisted_2
        ]),
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_unref(title))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h3", {
                  class: "text-lg leading-6 font-medium text-gray-900 truncate",
                  id: "sidepage-headline",
                  textContent: _toDisplayString(_unref(title))
                }, null, 8, _hoisted_4),
                (_unref(subtitle))
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      textContent: _toDisplayString(_unref(subtitle)),
                      class: "mt-1 text-sm text-gray-500 truncate"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 8, ["panel", "close"]))
}
}

})